import { Link } from "react-router-dom";

var WhooosReadingServices = require("lib/web/WhooosReadingServices")
var ContactModal = require("components/support/ContactModal");
var CurrentUser = require("lib/account/CurrentUser");

var HelpCenterLink = require('components/support/help_center_link');

require("layout/site_footer.scss");

class SiteFooter extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onClick(e) {
		$wr.nope(e)
		this.refs.modal.show();
	}

	getHiddenInfo() {
		if (CurrentUser.isLoaded()){
			var user = CurrentUser.get()
			var infoLine = "ID: " + user.id + " | CreatedAt: " + user.created_at;
			infoLine += " | Product: " + user.product + " | Role: " + user.role;
			if (user.demo) {
				infoLine += " | Demo: " + user.demo;
			}
			return infoLine;
		} else {
			return "CurrentUser Not Loaded"
		}
	}

	render() {
		if (CurrentUser.isLoaded() && !CurrentUser.isStudent()){
			var contactLink = (
				<p>
					<a href="#" onClick={ this.onClick } className="footerLink">Contact</a>
				</p>
			)
			var helpCenter = <HelpCenterLink />
		}
		
		return (
			<footer className="clearfix siteFooter hideOnPrint">
				<div className="container">
					<div className="navigationArea clearfix">
						<div className="faviconColumn">
							<p className="faviconP">
								<img src={ require("logos/wr-favicon-white.png") } className="favicon" />
							</p>
						</div>
						<div className="linkColumn">
							<p className="footerColumnLabel">About</p>
							<p>
								<a href={ WhooosReadingServices.OuterPages.url("/teachers") } 
									className="footerLink">Teachers</a>
							</p>
							<p>
								<a href={ WhooosReadingServices.OuterPages.url("/schools") } 
									className="footerLink">Schools</a>
							</p>
							<p>
								<a href={ WhooosReadingServices.OuterPages.url("/about_us") } 
									className="footerLink">Company</a>
							</p>
						</div>
						<div className="linkColumn">
							<p className="footerColumnLabel">Support</p>
							<p>
								<a href="https://whooosreading.zendesk.com/hc" className="footerLink">
									Help
								</a>
							</p>
							{ contactLink }
						</div>
					</div>
					<div className="row">
						<div className="col-sm-12">
							<p className="legal">
								(c) { new Date().getFullYear() } Whooo's Reading | { " " }
								<a href={ WhooosReadingServices.OuterPages.url("/terms") } 
									className="legalLink">Terms</a> | { " " }
								<a href={ WhooosReadingServices.OuterPages.url("/privacy") } 
									className="legalLink">Privacy</a>
							</p>
							<p className="hiddenInfo">
								{ this.getHiddenInfo() }
							</p>
						</div>
					</div>
				</div>

				<ContactModal ref="modal" />
				{ helpCenter }
			</footer>
		)
	}
};

SiteFooter.propTypes = StrictPropTypes({
});

module.exports = SiteFooter;



// WEBPACK FOOTER //
// ./modules/components/layout/SiteFooter.js